export default function br2nl(str: string) {
  return str.replace(/<br\s*\/?>/gm, '\n');
}
